import { Box, Stack, Text } from "@chakra-ui/react";
import React from "react";
import { ReactNode } from "react";

interface NavGroupProps {
  label: string;
  children: ReactNode;
}

export const NavGroup = (props: NavGroupProps) => {
  const { label, children } = props;
  return (
    <Box w="full" justifyContent="center">
      <Text
        px="3"
        fontSize="xs"
        fontWeight="semibold"
        textTransform="uppercase"
        letterSpacing="widest"
        color="gray.500"
        mb="3"
        {...props}
      >
        {label}
      </Text>
      <Stack spacing="1">{children}</Stack>
    </Box>
  );
};
